export default __webpack_public_path__ + "static/media/locatemarker.018182ac.svg";